import { Injectable, inject } from '@angular/core';
import { CommonRoute } from '../../enums/common-route.enum';
import { PlatformService } from '../platform/platform.service';

@Injectable({ providedIn: 'root' })
export class ReturnUrlService {
  private readonly platformService = inject(PlatformService);


  getSanitizedReturnUrl(rawUrl?: string): string {
    let baseHref = '/';
    if (this.platformService.isWeb) {
      baseHref =
        this.platformService
          .getDocument()
          ?.querySelector('base')
          ?.getAttribute('href') ?? '/';
    }

    let returnUrl = rawUrl ?? '/';
    if (this.platformService.isWeb && !rawUrl) {
      returnUrl = this.platformService.getWindow()?.location.pathname ?? '/';
    }

    const normalizedBaseHref = baseHref.endsWith('/')
      ? baseHref
      : baseHref + '/';
    if (
      normalizedBaseHref !== '/' &&
      returnUrl.startsWith(normalizedBaseHref)
    ) {
      returnUrl = returnUrl.slice(normalizedBaseHref.length - 1);
      if (!returnUrl.startsWith('/')) {
        returnUrl = '/' + returnUrl;
      }
    } else if (baseHref === '/' && !returnUrl.startsWith('/')) {
      returnUrl = '/' + returnUrl;
    }

    const queryParamIndex = returnUrl.indexOf('?');
    if (queryParamIndex !== -1) {
      returnUrl = returnUrl.substring(0, queryParamIndex);
    }

    const isSafe =
      typeof returnUrl === 'string' &&
      returnUrl.startsWith('/') &&
      !returnUrl.startsWith('//') &&
      returnUrl !== CommonRoute.LOGIN;

    return isSafe ? returnUrl : CommonRoute.HOME;
  }
}
